import React from 'react';

import { OAuthButtonProps } from '../types/auth';

import '../styles/auth.css';

const Spinner: React.FC = () => (
  <svg className="oauth-spinner" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeDasharray="50 20" />
  </svg>
);

export const OAuthButton: React.FC<OAuthButtonProps> = ({
  icon,
  label,
  onClick,
  isLoading,
  disabled,
}) => (
  <button className="oauth-button" onClick={onClick} disabled={disabled || isLoading}>
    <span className="oauth-icon">{isLoading ? <Spinner /> : icon}</span>
    <span>{label}</span>
  </button>
);
